export { ShippingProtectionCharityContent } from './shipping-protection-charity-content'
